import ReactDOM from "react-dom/client";
import Main from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(<Main />);
